import React from 'react';
import { Brand } from './PaymentStateScreen';
import './PaymentStateScreen.css';
import './PaymentConfirmation.css';

const PATHS = {
    check: <polyline points="20 6 9 17 4 12" />,
    card: (<><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></>),
    clock: (<><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></>),
    building: (<><rect x="4" y="2" width="16" height="20" rx="2" /><line x1="9" y1="22" x2="9" y2="16" /><line x1="15" y1="22" x2="15" y2="16" /><line x1="8" y1="6" x2="8.01" y2="6" /><line x1="12" y1="6" x2="12.01" y2="6" /><line x1="16" y1="6" x2="16.01" y2="6" /><line x1="8" y1="10" x2="8.01" y2="10" /><line x1="12" y1="10" x2="12.01" y2="10" /><line x1="16" y1="10" x2="16.01" y2="10" /></>),
    mail: (<><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></>),
    phone: <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />,
    plane: <polygon points="3 11 22 2 13 21 11 13 3 11" />,
    user: (<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>),
    list: (<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></>)
};

export const Icon = ({ name, className }) => (<svg className={className} viewBox="0 0 24 24" aria-hidden="true">{PATHS[name] || PATHS.check}</svg>);

export function ConfirmationPage({ children }) {
    return (
        <div className="pc-page">
            <div className="pc-container">{children}</div>
            <Brand />
        </div>
    );
}

export function ConfirmationHero({ title, children }) {
    return (
        <div className="pc-hero">
            <div className="pc-hero-icon"><Icon name="check" /></div>
            <h1>{title}</h1>
            {children}
        </div>
    );
}

/** rows: [{ label, value, tone?: 'mono' | 'accent', href?, balance? }] */
export function ConfirmationRows({ rows }) {
    return (
        <div className="pc-rows">
            {rows.filter(r => r && r.value !== undefined && r.value !== null && r.value !== '').map(r => (
                <div className={`pc-row${r.balance ? ' is-balance' : ''}`} key={r.label}>
                    <span>{r.label}</span>
                    {r.href ? <a href={r.href}>{r.value}</a> : <span className={r.tone ? `is-${r.tone}` : undefined}>{r.value}</span>}
                </div>
            ))}
        </div>
    );
}

export function ConfirmationPanel({ title, rows, children }) {
    return (
        <section className="pc-panel">
            {title && <h2>{title}</h2>}
            {rows && <ConfirmationRows rows={rows} />}
            {children}
        </section>
    );
}

export function ConfirmationCallout({ title, children }) {
    return (
        <section className="pc-callout">
            {title && <h2>{title}</h2>}
            {children}
        </section>
    );
}

/** items: [{ icon, content }] */
export function ConfirmationSteps({ items }) {
    return (
        <ul className="pc-steps">
            {items.filter(Boolean).map((item, i) => (
                <li className="pc-step" key={i}>
                    <span className="pc-step-icon"><Icon name={item.icon} /></span>
                    <span className="pc-step-body">{item.content}</span>
                </li>
            ))}
        </ul>
    );
}

export function ConfirmationContacts({ items }) {
    return items.filter(i => i && i.value).map(i => (
        <div className="pc-contact" key={i.icon + i.value}>
            <Icon name={i.icon} />
            {i.href ? <a href={i.href}>{i.value}</a> : <span>{i.value}</span>}
        </div>
    ));
}

export function ConfirmationFooter({ children }) {
    return <div className="pc-footer">{children}</div>;
}
